<div class="row">
    <div class="col-12 col-md-4 col-lg-4 col-xl-3 pb-md-0 pb-sm-4 pb-xs-2">
        <pmd-card class="px-3 pt-3 box-shadow-none mb-0 h-100">
            <h4 class="h5 cart-title d-flex mb-1">
                <span class="text-dark">Summary of Invoices</span>
                <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
                    container="body"
                    pmdTooltip="Shows the number of invoices being uploaded over the selected date range."
                    placement="bottom">info</i>
            </h4>
            <app-table-loader *ngIf="isSatusWiseSummaryLoading"
                class="h-100 d-flex align-items-center">
            </app-table-loader>
            <div *ngIf="!isSatusWiseSummaryLoading"
                class="d-flex flex-md-column flex-sm-row flex-column">
                <ng-container *ngIf="totalInvoiceCount < 1; else elseBlock">
                    <div class="position-relative">
                        <div class="total-invoice">
                            <ng-container>
                                <span>
                                    <p>Invoices have not been uploaded for the selected date range.</p>
                                </span>
                            </ng-container>
                        </div>
                        <div class="empty-donut mb-4">
                            <img src="assets/images/empty-donut.png"
                                alt="Empty"
                                class="img-fluid" />
                        </div>
                    </div>
                </ng-container>
                <ng-template #elseBlock>
                    <div class="position-relative">
                        <div class="total-invoice">
                            <span>
                                Total No. of Invoices
                            </span>
                            <span class="count-number">
                                {{ sharedService.formatNumber(totalInvoiceCount) }}
                            </span>
                        </div>
                        <app-donut-chart [series]="donutSeries"></app-donut-chart>
                    </div>
                </ng-template>

                <div class="invoice-count mt-3">
                    <div class="d-flex count-reviewed">
                        <div class="invoice-circle-color me-2">
                            <span class="status-reviewed-count"></span>
                        </div>
                        <div class="w-100">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <p class="mb-0 title-count">Reviewed</p>
                                <div class="h3 mb-0 text-black">
                                    {{ sharedService.formatNumber(statusWiseInvoiceCount.reviewed) }}
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between w-100 mt-1">
                                <p class="mb-0 title-count">Invoice(s) :
                                    <strong>
                                        {{sharedService.formatNumber(documentTypeInvoiceCount.taxInvoice)}}
                                    </strong>
                                </p>
                                <p class="mb-0 title-count text-end">Credit Note(s) :
                                    <strong>
                                        {{sharedService.formatNumber(documentTypeInvoiceCount.creditNote) }}
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex count-pending">
                        <div class="invoice-circle-color me-2">
                            <span class="status-in-process-count"></span>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100">
                            <p class="mb-0 title-count">Pending</p>
                            <div class="h3 mb-0 text-black">
                                {{ sharedService.formatNumber(statusWiseInvoiceCount.pending) }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex count-rejected">
                        <div class="invoice-circle-color me-2">
                            <span class="status-rejected-count"></span>
                        </div>
                        <div class="w-100">
                            <div class="d-flex align-items-center justify-content-between w-100">
                                <p class="mb-0 title-count ">Invalid</p>
                                <div class="h3 mb-0 text-black">
                                    {{ sharedService.formatNumber(statusWiseInvoiceCount.invalid) }}
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between w-100 mt-1">
                                <p class="mb-0 title-count">Failed :
                                    <strong>
                                        {{ sharedService.formatNumber(statusWiseInvoiceCount.failed) }}
                                    </strong>
                                </p>
                                <p class="mb-0 title-count">Duplicate :
                                    <strong>
                                        {{ sharedService.formatNumber(statusWiseInvoiceCount.duplicate) }}
                                    </strong>
                                </p>
                                <p class="mb-0 title-count text-end">Rejected :
                                    <strong>
                                        {{ sharedService.formatNumber(statusWiseInvoiceCount.rejected) }}
                                    </strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </pmd-card>
    </div>
    <div class="col-12 col-md-8 col-lg-8 col-xl-9 pb-0">
        <pmd-card class="px-3 pt-3 box-shadow-none mb-0 h-100">
            <h4 class="h5 cart-title d-flex align-items-center mb-3">
                <span class="text-dark">Invoice and Amount Summary</span>
                <i class="material-icons md-dark pmd-icon-xs pmd-accordion-arrow ms-1 pf-cursor-pointer opacity-75"
                    container="body"
                    pmdTooltip="Shows the invoice count, taxable amount, and GST amount of the invoices reviewed."
                    placement="bottom">info</i>
            </h4>
            <div class="statistic-total my-2">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xl-4"
                        *ngIf="!isInvoiceAmountLoading && invoiceAmount.amount">
                        <div class="total-card total-amount">
                            <div class="card-subtitle">
                                <p class="mb-0">Total Payable Amount</p>
                            </div>
                            <app-table-loader *ngIf="isInvoiceAmountLoading"></app-table-loader>
                            <div *ngIf="!isInvoiceAmountLoading"
                                class="growth-rate d-flex align-items-end justify-content-between">
                                <div class="h3 mb-0 text-black">
                                    {{ sharedService.formatNumber(invoiceAmount.amount, true) }}
                                </div>
                                <!-- <span class="d-flex align-items-center percentage-value">
                                    <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                                        {{ invoiceAmount.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                                    </i>
                                    <span class="pf-cursor-pointer"
                                        container="body"
                                        pmdTooltip="Your total payable amount of invoices has {{ invoiceAmount.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(invoiceAmount.change >= 0 ? invoiceAmount.change : invoiceAmount.change * -1) }}% compared to the previous period."
                                        placement="bottom">
                                        {{ sharedService.formatNumber(invoiceAmount.change) }}%
                                    </span>
                                </span> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xl-4"
                        *ngIf="!isInvoiceGstLoading && invoiceGst.gst">
                        <div class="total-card total-gst">
                            <div class="card-subtitle">
                                <p class="mb-0 w-100">Total Taxes</p>
                            </div>
                            <app-table-loader *ngIf="isInvoiceGstLoading"></app-table-loader>
                            <div *ngIf="!isInvoiceGstLoading"
                                class="growth-rate d-flex align-items-end justify-content-between">
                                <div class="h3 mb-0 text-black">
                                    {{ sharedService.formatNumber(invoiceGst.gst, true) }}
                                </div>
                                <!-- <span class="d-flex align-items-center percentage-value">
                                    <i class="material-symbols-outlined material-icons-round pmd-icon-xs me-1">
                                        {{ invoiceGst.change >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                                    </i>
                                    <span class="pf-cursor-pointer"
                                        container="body"
                                        pmdTooltip="Your total taxes of invoices has {{ invoiceGst.change >= 0 ? 'increased' : 'decreased' }} by {{ sharedService.formatNumber(invoiceGst.change >= 0 ? invoiceGst.change : invoiceGst.change * -1) }}% compared to the previous period."
                                        placement="bottom">
                                        {{ sharedService.formatNumber(invoiceGst.change) }}%
                                    </span>
                                </span> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chart-wrapper">
                <div class="chart-empty d-flex flex-column justify-content-center align-items-center pt-lg-5"
                    *ngIf="isTimeWiseSummaryLoading">
                    <div class="row text-center justify-content-center">
                        <div class="col-12 col-lg-8">
                            <app-table-loader></app-table-loader>
                        </div>
                    </div>
                </div>
                <!-- <div class="chart-filter">
                    <span class="badge me-1 bg-light text-dark"> Daily </span>
                    <span class="badge me-1 bg-secondary"> Weekly </span>
                    <span class="badge bg-light text-dark"> Monthly </span>
                </div> -->
                <app-mixed-chart *ngIf="!isTimeWiseSummaryLoading && !isChartEmpty"
                    [series]="mixedSeries"
                    [categories]="mixedCategories"
                    [yAxisRange]="mixedYAxisRange"
                    [isProduct]="false"
                    [isXCapitalized]="false"
                    [customTooltip]="mixedCustomTooltip">
                </app-mixed-chart>
            </div>
            <app-empty-chart *ngIf="!isTimeWiseSummaryLoading && isChartEmpty">
            </app-empty-chart>
        </pmd-card>
    </div>
</div>